import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLMARUBOZU', label: 'Marubozu', lookback: 10 })
